import styled, { css } from "styled-components";

interface IPropTypes {
  $maxWidth?: number | string;
  $minHeight?: number | string;
  $maxHeight?: number | string;
  $horizontal?: boolean;
  $hideScrollBar?: boolean;
}

export const ScrollWrapper = styled.div<IPropTypes>`
  -webkit-overflow-scrolling: touch;
  ${(props) =>
    !props.$hideScrollBar
      ? ""
      : css`
          scrollbar-width: none;

          &::-webkit-scrollbar {
            -webkit-appearance: none;
            height: 0;
          }

          &::-webkit-scrollbar-thumb {
            background-color: rgba(0, 0, 0, 0);
          }
        `};
  ${(props) =>
    props.$horizontal
      ? css`
          overflow-y: hidden;
          overflow-x: auto;
        `
      : css`
          overflow-x: hidden;
          overflow-y: auto;
        `};
  ${(props) => {
    const value =
      typeof props.$maxWidth === "number"
        ? css`
            ${props.$maxWidth}px
          `
        : props.$maxWidth;

    return !props.$maxWidth
      ? ""
      : css`
          width: ${value};
          max-width: ${value};
        `;
  }};
  ${({ $minHeight: minHeight }) => {
    const value =
      typeof minHeight === "number"
        ? css`
            ${minHeight}px
          `
        : minHeight;
    return minHeight
      ? css`
          min-height: ${value};
        `
      : "";
  }};
  ${(props) => {
    const value =
      typeof props.$maxHeight === "number"
        ? css`
            ${props.$maxHeight}px
          `
        : props.$maxHeight;

    return !props.$maxHeight
      ? ""
      : css`
        height: ${value}
        max-height: ${value}`;
  }};
`;
